import { IUtilsState } from "./types";
import { Instance, Languages } from "@const/consts";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import LocalStorageService from "@services/localStorage";

const initialState: IUtilsState = {
  instance: (LocalStorageService.getInstance() as Instance) ?? Instance.GLOBAL,
  language: LocalStorageService.getLanguage() ?? Languages.EN,
};

export const utilsSlice = createSlice({
  initialState,
  name: "utils",
  reducers: {
    setInstance: (state, action) => {
      state.instance = action.payload;
    },
    setLanguage: (state, action: PayloadAction<string>) => {
      state.language = action.payload;
    },
  },
});

const { actions, reducer } = utilsSlice;

export const {
  setInstance,
  setLanguage,
} = actions;

export default reducer;
